// extracted by mini-css-extract-plugin
export var dateTimeButton = "_fg-1";
export var dateTimeButtonsContainer = "_fg-6";
export var dateTimeInputContainer = "_fg-7";
export var dateTimeWrapper = "_fg-8";
export var disabledTile = "_fg-0";
export var header = "_fg-2";
export var line = "_fg-3";
export var snoozeOption = "_fg-4";
export var time = "_fg-5";
export var todayTile = "_fg-9";
export var wrapper = "_fg-a";